import { memo, useCallback } from "react";
import {
  Group,
  Flex,
  Text,
  Box,
  Button,
  Avatar,
  useMantineTheme,
} from "@mantine/core";
import { openModal } from "@mantine/modals";
import SelectMember, { attendeeDetail } from "./SelectMember";
import { useCatalogContext } from "src/api/context/CatalogContext";
import { ModalId } from "src/utils/constants";

const borderBottom = "1px solid #DDDDDD";

function Customer() {
  const theme = useMantineTheme();
  const { selectedCustomer } = useCatalogContext();
  const { name, memberStatus, profilePicUrl } =
    attendeeDetail(selectedCustomer);

  const handleModal = useCallback(() => {
    openModal({
      modalId: ModalId.CheckoutCustomer,
      closeOnClickOutside: false,
      title: "Select a Member, Guest, or Lead",
      children: <SelectMember />,
    });
  }, []);

  return (
    <>
      <Box sx={{ borderBottom }} pb={6} mb={8}>
        <Text size={18} fw={500}>
          Customer
        </Text>
      </Box>

      <Box
        bg={theme.colors.secondary[1]}
        p="25px 12px"
        sx={{ maxWidth: 400, borderRadius: 8, width: "100%" }}
      >
        <Flex align={"center"} justify={"space-between"}>
          {selectedCustomer ? (
            <Group>
              <Avatar radius="xl" color="primary" src={profilePicUrl || ""} />
              <Box>
                <Text size={14}>{name}</Text>
                <Text size={14} fw={500}>
                  {memberStatus}
                </Text>
              </Box>
            </Group>
          ) : (
            <Text color={theme.colors.secondaryTextColor[1]} fw={500} pl={"xl"}>
              None Selected
            </Text>
          )}
          <Button
            onClick={handleModal}
            sx={{
              "&:hover": {
                backgroundColor: theme.colors.primary[4],
              },
            }}
          >
            {selectedCustomer ? "Change" : "Select"}
          </Button>
        </Flex>
      </Box>
    </>
  );
}

export default memo(Customer);
